import {FC} from "react";
import styles from "./SideBarHeader.module.scss";
import {IFlightReport} from "../../../../model/IFlightReport";
import {GoAContainer} from "@abgov/react-components";
const {headerTitle, headerData, headerDataTitle, headerDataBody} = styles;
interface ISideBarHeaderProps {
    flightReport: IFlightReport;
    isEdit?: boolean;
}

const SideBarHeader: FC<ISideBarHeaderProps> = ({flightReport, isEdit}) => {
    return (
        <GoAContainer
            type="non-interactive"
            accent="thick"
            heading={flightReport.status}
        >
            <div className={headerTitle}>
                {!flightReport.flightReportId
                    ? "Create new flight report"
                    : `Flight report ${flightReport.flightReportId}`}
            </div>
            <div className={headerData}>
                <div className={headerDataTitle}>Flight date</div>
                <div className={headerDataTitle}>Contract registration</div>
                <div className={headerDataBody}>
                    {flightReport.flightReportDate
                        ? flightReport.flightReportDate
                        : "-"}
                </div>
                <div className={headerDataBody}>
                    {flightReport.contractRegistration
                        ? flightReport.contractRegistration.aircraftRegistration
                        : "-"}
                </div>
            </div>
        </GoAContainer>
    );
};
export default SideBarHeader;
